import { Model } from 'es6/components/model'
import Backbone from 'init/backbone'
import { CartDiscountMixin } from 'es6/mixins/cart-discount-mixin'
import extend from 'lodash/extend'
import { entryScriptName } from 'init/entry-script-name'
import { Defaults } from 'es-decorators'

/**
 * Модель для товара в корзине
 */
@Defaults({
  defaults: {
    qty: '',
    cart_id: 'main',
  },
  idAttribute: 'item_id',

  url: `${entryScriptName}/api/v3/cart-item/`,
})
export class CartItem extends Model {
  /**
   * @inheritDoc
   */
  run (attrs, options) {
    if (options && options.item) {
      this.set('item', options.item)
    }
  }

  /**
   * @inheritDoc
   */
  parse (resp) {
    Backbone.trigger('update-cart-info', { cartInfo: resp._cart })
    if (resp['_paid-delivery']) {
      Backbone.trigger('update-paid-delivery', { paidDelivery: resp['_paid-delivery'] })
    }
    if (resp._volume_discount && resp._wholesale) {
      Backbone.trigger('update-discount', { discount: this.getDiscountData(resp) })
    }
    if (resp._meta && resp._meta.gifts) {
      Backbone.trigger('gift-deleted-from-cart', resp._meta.gifts)
    }
    return resp
  }
  /**
   * Проверяет, является ли товар транзитом, недоступным для доставки в город.
   * @param {number} settlementId id текущего города.
   * @returns {boolean} Булево значение.
   */
  isDisabledTransit (settlementId) {
    let transitSettlements = this.get('item') && this.get('item').transit_in_settlement
    return transitSettlements
      && transitSettlements.length
      && transitSettlements.indexOf(settlementId) === -1
  }
}

extend(CartItem.prototype, CartDiscountMixin)
